import { Briefcase, Store } from 'lucide-react'
import { SERVICE_MENU } from './serviceCatalog'

// Header navigation: four dropdowns (Who We Help, Services, Results, Company).
// Existing pages only. The desktop panels lay these lists out individually in
// App.jsx; NAV_SECTIONS flattens them into plain link groups for the mobile
// drawer and for marking the current section in the bar.

// The two doors match the homepage hero buttons (HeroV2.jsx).
export const AUDIENCE_DOORS = [
  {
    label: 'I Own a Business',
    description: 'We set up and run GoHighLevel for your company.',
    tag: 'Plans from $149/month',
    to: '/for-business-owners',
    icon: Store,
    featured: true,
  },
  {
    label: 'I Run an Agency',
    description: 'Your behind-the-scenes GoHighLevel team, under your brand.',
    tag: 'No long-term contract',
    to: '/for-agency-owners',
    icon: Briefcase,
  },
]

export const HIRE_SPECIALIST = {
  label: 'Hire One Specialist',
  description: 'Bring in a single expert for a specific project',
  to: '/hire-an-individual',
}

export const INDUSTRIES = [
  { label: 'Real Estate', to: '/industries/real-estate' },
  { label: 'Dental Practices', to: '/industries/dental' },
  { label: 'HVAC Contractors', to: '/industries/hvac' },
  { label: 'Home Services', to: '/industries/home-services' },
  { label: 'Law Firms', to: '/industries/law' },
]

export const RESULTS_LINKS = [
  { label: 'Case Studies', description: 'Real builds and the results they delivered', to: '/case-studies' },
  { label: 'Client Reviews', description: 'What clients say on Upwork, Fiverr and LinkedIn', to: '/reviews' },
  { label: 'GHL Prime vs Others', description: 'How we compare with freelancers, in-house hires and agencies', to: '/compare' },
]

export const COMPANY_LINKS = [
  { label: 'About Us', description: 'Our story and how we work', to: '/about' },
  { label: 'Our Team', description: 'The people behind your builds', to: '/team' },
  { label: 'Gallery', description: 'Moments from life at GHL Prime', to: '/gallery' },
  { label: 'Blog', description: 'GoHighLevel guides and updates', to: '/blog' },
  { label: 'FAQ', description: 'Answers before you work with us', to: '/faq' },
  { label: 'GoHighLevel Glossary', description: 'GHL terms in plain English', to: '/glossary' },
]
// Contact isn't listed: it's a button in the bar and in the mobile drawer.

export const NAV_SECTIONS = [
  {
    key: 'who',
    label: 'Who We Help',
    groups: [
      { heading: 'By role', items: [...AUDIENCE_DOORS, HIRE_SPECIALIST] },
      { heading: 'By industry', items: INDUSTRIES },
    ],
  },
  {
    key: 'services',
    label: 'Services',
    allLink: { label: 'All Services', to: '/services' },
    groups: SERVICE_MENU.map((col) => ({ heading: col.category, items: col.items })),
  },
  { key: 'results', label: 'Results', groups: [{ items: RESULTS_LINKS }] },
  { key: 'company', label: 'Company', groups: [{ items: COMPANY_LINKS }] },
]

/** True when `pathname` belongs to this section, for the bar's active state. */
export function isSectionActive(section, pathname) {
  if (section.key === 'services' && pathname.startsWith('/services')) return true
  if (section.key === 'who' && pathname.startsWith('/industries')) return true
  return section.groups.some((group) => group.items.some((item) => item.to === pathname))
}
